export class ColorUtil {
  static numberToHex(color: number): string {
    if (!color) return "#000000";
    return "#" + color.toString(16).padStart(6, "0").toUpperCase();
  }

  static isValidHex(color: string): boolean {
    if (!color.startsWith("#"))
      return false;
    const numberString = color.substring(1);
    console.log("numberString");

    switch (numberString.length) {
      case 3:
        return /^[0-9A-F]{3}$/i.test(numberString);
      case 6:
        return /^[0-9A-F]{6}$/i.test(numberString);
      case 8:
        return /^[0-9A-F]{8}$/i.test(numberString);
    }
    return false;
  }

  static hexToNumber(color: string): number {
    if (color.startsWith("#")) color = color.substring(1).padStart(6, "0");
    const num = Number.parseInt(color, 16);
    return num;
  }

  static hexToRgb(color: string): { r: number; g: number; b: number } {
    if (color.startsWith("#")) {
      color = color.substring(1);
    }
    if (color.length === 3) {
      return {
        r: Number.parseInt(color.substring(0, 1), 16) * 17,
        g: Number.parseInt(color.substring(1, 2), 16) * 17,
        b: Number.parseInt(color.substring(2, 3), 16) * 17,
      };
    }
    color = color.padStart(6, "0");
    return {
      r: Number.parseInt(color.substring(0, 2), 16),
      g: Number.parseInt(color.substring(2, 4), 16),
      b: Number.parseInt(color.substring(4, 6), 16),
    };
  }

  static grey(color: number): number {
    const r = (color >>> 16) & 0xff;
    const g = (color >>> 8) & 0xff;
    const b = (color >>> 0) & 0xff;
    const greyVal = r * 0.2126 + g * 0.7152 + b * 0.0722;
    // console.log("r: ", r, g, b, greyVal);
    return Math.round(greyVal);
  }

  static rgbToNumber(r: number, g: number, b: number, a?: number): number {
    const _r = (r & 0xff) << 16;
    const _g = (g & 0xff) << 8;
    // const _b = (b & 0xff);
    // const _a = (a !== undefined ? (a & 0xff) : 0xff) * 256 * 256 * 256;
    const _b = b & 0xff;
    const _a = (a ? a & 0xff : 255) * 256 * 256 * 256;
    return _r + _g + _b + _a;
  }

  static numberToRgb(color: number): { a: number; r: number; g: number; b: number } {
    return {
      a: (color >>> 16) & 0xff,
      r: (color >>> 16) & 0xff,
      g: (color >>> 8) & 0xff,
      b: color & 0xff,
    };
  }
}
